module.exports = __webpack_public_path__ + "assets/dashboard-icon-videosPlayed-selected.3dee9b95.svg";